/**
 * Common function for dialog callback
 */
exports.commonDialogCallback = () => {
    $('body').addClass('ui-dialog-prevent-scroll');
    $('.dialog-content').append(
        '<button class="ui-dialog-titlebar-close"><span class="icon icon-icon-menu-close"></span></button>'
    );
    $('.ui-dialog-titlebar-close').on('click', event => {
        event.preventDefault();
        $('.ui-dialog').remove();
        $('body').removeClass('ui-dialog-prevent-scroll');
    });
};
/**
 * Common function to close dialog
 */
exports.commonDialogCloseCallback = () => {
    $('body').removeClass('ui-dialog-prevent-scroll');
};
